import { render } from "./mobilemenu.vue?vue&type=template&id=33cad8d2"
import script from "./mobilemenu.vue?vue&type=script&lang=js"
export * from "./mobilemenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__